"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Player = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reportTemplates = _interopRequireDefault(require("./reportTemplates.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var reportList = (0, _get2["default"])(window, 'cccisd.appDefs.reports.list', []);
var Player = exports.Player = /*#__PURE__*/function (_React$Component) {
  _inherits(Player, _React$Component);
  function Player() {
    _classCallCheck(this, Player);
    return _callSuper(this, Player, arguments);
  }
  _createClass(Player, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        pawnId = _this$props.pawnId,
        settings = _this$props.settings,
        showRequiredState = _this$props.showRequiredState,
        isSavingMetrics = _this$props.isSavingMetrics,
        isPreview = _this$props.isPreview;
      var elementStyle = (0, _get2["default"])(this.props, 'playerTemplateProps.playerTemplateSettings.elementStyle');
      var reportTemplate;
      var report;
      if (!isPreview && isSavingMetrics && settings.report) {
        report = reportList.find(function (item) {
          return item.id === settings.report;
        });
        if (report) {
          reportTemplate = _reportTemplates["default"].find(function (item) {
            return item.handle === report.reportTemplateHandle;
          });
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: [_cccisdSurveyCommon.commonStyle.lastRow, _cccisdSurveyCommon.commonStyle.elementWrapper, _cccisdSurveyCommon.commonStyle[elementStyle]].join(' ')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.margin
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: settings.question,
        registerAction: this.props.registerAction.bind(null, 1),
        setParameters: this.props.setParameters,
        showRequiredState: showRequiredState && settings.isRequired
      }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].description
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: settings.description
      }))), reportTemplate ? /*#__PURE__*/_react["default"].createElement(reportTemplate.player, {
        settings: report.reportTemplateSettings,
        widgetProps: _objectSpread(_objectSpread({}, reportTemplate.widgetProps), {}, {
          pawnId: pawnId
        })
      }) : /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].report
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '0.5em'
        }
      }, settings.report), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-muted"
      }, !isPreview && /*#__PURE__*/_react["default"].createElement("div", null, "Report is not available in Preview mode"))));
    }
  }]);
  return Player;
}(_react["default"].Component);
_defineProperty(Player, "propTypes", {
  field: _propTypes["default"].object,
  settings: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  pawnId: _propTypes["default"].number,
  playerTemplateProps: _propTypes["default"].object,
  showRequiredState: _propTypes["default"].bool,
  isSavingMetrics: _propTypes["default"].bool,
  isPreview: _propTypes["default"].bool
});
_defineProperty(Player, "defaultProps", {
  registerAction: function registerAction() {},
  setParameters: function setParameters() {}
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({})(Player);